
const libPictTemplate = require('pict-template');

class PictTemplateProviderHumanCount extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~HumanCount:', '~}');
	}

	/**
	 * Format count as human-readable text (ex. 135k, 257M).
	 *
	 * @param {number} count - Count to summarize.
	 * @param {number} [dp] - Number of decimal places to display.
	 *
	 * @return {string} Human-readable text.
	 */
	humanFileSize(count, dp = 1)
	{
		const thresh = 1000;

		if (Math.abs(count) < thresh)
		{
			return String(count);
		}

		const units = [ 'k', 'M', 'B' ];
		let u = -1;
		const r = 10 ** dp;

		do
		{
			count /= thresh;
			++u;
		}
		while (Math.round(Math.abs(count) * r) / r >= thresh && u < units.length - 1);


		return count.toFixed(dp) + units[u];
	}

	render(pTemplateHash, pRecord, pContextArray)
	{
		const [ tmpHash, tmpPrecision ] = pTemplateHash.trim().split('^');
		const tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fHumanCount]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fHumanCount]::[${tmpHash}]`);
		}

		let tmpValue;
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray);
		}
		if ((tmpValue == null) || (tmpValue == 'undefined') || (typeof(tmpValue) == 'undefined'))
		{
			return '';
		}
		return this.humanFileSize(tmpValue, tmpPrecision ? parseInt(tmpPrecision) : 1);
	}
}

module.exports = PictTemplateProviderHumanCount;
